"use strict";

(function (window, document) {
	if (
		!document.createElementNS ||
		!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect
	)
		return true;
	var isLocalStorage =
			"localStorage" in window && window["localStorage"] !== null,
		request,
		data,
		insertIT = function () {
			document.body.insertAdjacentHTML("afterbegin", data);
		},
		insert = function () {
			if (document.body) insertIT();
			else document.addEventListener("DOMContentLoaded", insertIT);
		};
	if (isLocalStorage && localStorage.getItem("inlineSVGrev") == revision) {
		data = localStorage.getItem("inlineSVGdata");
		if (data) {
			insert();
			return true;
		}
	}
	try {
		request = new XMLHttpRequest();
		request.open("GET", file, true);
		request.onload = function () {
			if (request.status >= 200 && request.status < 400) {
				data = request.responseText;
				insert();
				if (isLocalStorage) {
					localStorage.setItem("inlineSVGdata", data);
					localStorage.setItem("inlineSVGrev", revision);
				}
			}
		};
		request.send();
	} catch (e) {}
})(window, document);

let lenisScroll = null;
let scrollTopPos = 0;
let __justClosedModal = false;
const isMobile = (() => {
	const userAgent = navigator.userAgentData
		? navigator.userAgentData.brands.map((b) => b.brand).join(" ")
		: navigator.userAgent;

	const devicePatterns = {
		Android: /Android/i,
		BlackBerry: /BlackBerry/i,
		iOS: /iPhone|iPad|iPod/i,
		Opera: /Opera Mini/i,
		Windows: /IEMobile/i,
	};

	const checkDevice = (device) => devicePatterns[device].test(userAgent);

	return {
		Android: () => checkDevice("Android"),
		BlackBerry: () => checkDevice("BlackBerry"),
		iOS: () => checkDevice("iOS"),
		Opera: () => checkDevice("Opera"),
		Windows: () => checkDevice("Windows"),
		any: () => Object.keys(devicePatterns).some(checkDevice),
	};
})();

// In-view Detect (IntersectionObserver with fallback)
function initInViewDetect(delay = 100) {
	// --- SplitText registry to support responsive reflow on resize
	const __splitRegistry = new WeakMap();
	let __splitResizeBound = false;

	function __animateHeadingLines(heading) {
		const duration = 0.8;
		const stagger = 0.08;
		const targets = heading.querySelectorAll(".line");
		if (!targets.length) return;
		heading.classList.add("in-view");
		gsap.fromTo(
			targets,
			{ yPercent: 110 },
			{ yPercent: 0, duration, stagger, ease: "osmo-ease" }
		);
	}

	function __escapeRegExp(str) {
		return String(str).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	}

	function __lineHasSignificantContent(line, excludeNode) {
		if (!line) return false;
		return Array.from(line.childNodes).some((node) => {
			if (excludeNode && node === excludeNode) return false;
			if (node.nodeType === 3) return node.textContent.trim().length > 0;
			if (node.nodeType === 1) return node.textContent.trim().length > 0;
			return false;
		});
	}

	function __trimLineStartWhitespace(line) {
		if (!line) return;
		let node = line.firstChild;
		while (node) {
			const next = node.nextSibling;
			if (node.nodeType === 3 && !node.textContent.trim()) {
				line.removeChild(node);
			} else {
				break;
			}
			node = next;
		}
	}

	function __trimLineEndWhitespace(line) {
		if (!line) return;
		let node = line.lastChild;
		while (node) {
			const prev = node.previousSibling;
			if (node.nodeType === 3 && !node.textContent.trim()) {
				line.removeChild(node);
			} else {
				break;
			}
			node = prev;
		}
	}

	function __collectTrailingDivInfo(heading) {
		if (!heading) return null;
		const lastChild = heading.lastElementChild;
		if (!lastChild || lastChild.tagName !== "DIV") return null;

		const info = {
			div: lastChild,
			fitsWithPrev: true,
			lastWordText: "",
		};

		let prev = lastChild.previousSibling;
		let candidate = null;
		while (prev) {
			if (prev.nodeType === 3 && prev.textContent.trim().length) {
				candidate = prev;
				break;
			}
			if (prev.nodeType === 1 && prev.textContent.trim().length) {
				candidate = prev;
				break;
			}
			prev = prev.previousSibling;
		}

		if (!candidate) return info;

		try {
			const divRect = lastChild.getBoundingClientRect();
			if (candidate.nodeType === 3) {
				const text = candidate.textContent || "";
				const trimmedRight = text.replace(/\s+$/, "");
				if (!trimmedRight.length) return info;
				const lastSpace = trimmedRight.lastIndexOf(" ");
				const wordStart = lastSpace === -1 ? 0 : lastSpace + 1;
				const word = trimmedRight.slice(wordStart);
				info.lastWordText = word;

				if (word) {
					const range = document.createRange();
					range.setStart(candidate, wordStart);
					range.setEnd(candidate, wordStart + word.length);
					const wordRect = range.getBoundingClientRect();
					if (wordRect && divRect && wordRect.height && divRect.height) {
						info.fitsWithPrev = Math.abs(wordRect.top - divRect.top) <= 1;
					}
					if (range.detach) range.detach();
				}
			} else if (candidate.nodeType === 1) {
				const text = candidate.textContent.trim();
				info.lastWordText = text;
				if (text) {
					const range = document.createRange();
					range.selectNode(candidate);
					const wordRect = range.getBoundingClientRect();
					if (wordRect && divRect && wordRect.height && divRect.height) {
						info.fitsWithPrev = Math.abs(wordRect.top - divRect.top) <= 1;
					}
					if (range.detach) range.detach();
				}
			}
		} catch (e) {
			info.fitsWithPrev = true;
		}

		return info;
	}

	function __popTrailingWordFromLine(line, expectedWord) {
		if (!line) return null;
		const pattern = expectedWord
			? new RegExp(`(\\s*)${__escapeRegExp(expectedWord)}\\s*$`)
			: /(\s*\S+)\s*$/;

		let node = line.lastChild;
		while (node) {
			const prev = node.previousSibling;
			if (node.nodeType === 3) {
				const text = node.textContent || "";
				const match = pattern.exec(text);
				if (match) {
					const start = text.length - match[0].length;
					const before = text.slice(0, start);
					if (before.length) {
						node.textContent = before;
					} else {
						line.removeChild(node);
					}
					const word = expectedWord || match[0].trim();
					if (!word) return null;
					return { node: document.createTextNode(word) };
				}
				if (!text.trim()) {
					line.removeChild(node);
				}
			} else if (node.nodeType === 1) {
				const text = node.textContent || "";
				if (!text.trim()) {
					line.removeChild(node);
					node = prev;
					continue;
				}
				if (!expectedWord || text.trim() === expectedWord) {
					line.removeChild(node);
					return { node };
				}
			} else {
				line.removeChild(node);
			}
			node = prev;
		}
		return null;
	}

	function __mergeTrailingDivIntoPrevLine(
		split,
		lines,
		targetIndex,
		trailingDiv
	) {
		if (targetIndex <= 0) return;
		const donorLine = lines[targetIndex - 1];
		const targetLine = lines[targetIndex];
		if (!donorLine || !targetLine) return;

		const lastChild = donorLine.lastChild;
		if (lastChild && lastChild !== trailingDiv) {
			const needsSpace =
				lastChild.nodeType !== 3 || !/\s$/.test(lastChild.textContent || "");
			if (needsSpace) donorLine.appendChild(document.createTextNode(" "));
		}

		donorLine.appendChild(trailingDiv);

		const targetMask = targetLine.parentElement;

		if (targetMask) {
			if (Array.isArray(split.masks)) {
				const maskIdx = split.masks.indexOf(targetMask);
				if (maskIdx > -1) split.masks.splice(maskIdx, 1);
			}
			targetMask.remove();
		} else {
			targetLine.remove();
		}

		lines.splice(targetIndex, 1);
	}

	function __moveLastWordWithDiv(
		split,
		lines,
		targetIndex,
		trailingDiv,
		expectedWord
	) {
		if (targetIndex <= 0) return;
		const donorLine = lines[targetIndex - 1];
		const targetLine = lines[targetIndex];
		if (!donorLine || !targetLine) return;

		const extraction = __popTrailingWordFromLine(donorLine, expectedWord);
		if (!extraction) return;

		__trimLineEndWhitespace(donorLine);

		const wordNode = extraction.node;
		if (!wordNode) return;

		if (wordNode.nodeType === 3) {
			wordNode.textContent = wordNode.textContent.trim();
			if (!wordNode.textContent) return;
		}

		__trimLineStartWhitespace(targetLine);

		targetLine.insertBefore(wordNode, trailingDiv);
		targetLine.insertBefore(document.createTextNode(" "), trailingDiv);

		if (!__lineHasSignificantContent(donorLine)) {
			const donorMask = donorLine.parentElement;
			if (donorMask) {
				if (Array.isArray(split.masks)) {
					const maskIdx = split.masks.indexOf(donorMask);
					if (maskIdx > -1) split.masks.splice(maskIdx, 1);
				}
				donorMask.remove();
			} else {
				donorLine.remove();
			}
			lines.splice(targetIndex - 1, 1);
		}
	}

	function __ensureTrailingDivPlacement(split, trailingInfo) {
		if (!split || !trailingInfo || !trailingInfo.div) return;
		const { div: trailingDiv, fitsWithPrev, lastWordText } = trailingInfo;
		const lines = Array.isArray(split.lines) ? split.lines : [];
		if (!lines.length) return;

		const targetIndex = lines.findIndex((line) => line.contains(trailingDiv));
		if (targetIndex < 0) return;
		const targetLine = lines[targetIndex];

		const hasOtherContent = __lineHasSignificantContent(
			targetLine,
			trailingDiv
		);

		if (fitsWithPrev) {
			if (!hasOtherContent) {
				__mergeTrailingDivIntoPrevLine(split, lines, targetIndex, trailingDiv);
			}
			return;
		}

		if (!hasOtherContent) {
			__moveLastWordWithDiv(
				split,
				lines,
				targetIndex,
				trailingDiv,
				lastWordText || ""
			);
		}
	}

	function __splitHeading(heading) {
		if (!heading) return null;
		const prevSplit = __splitRegistry.get(heading);
		try {
			prevSplit && prevSplit.revert && prevSplit.revert();
		} catch (e) {}
		const trailingInfo = __collectTrailingDivInfo(heading);
		const split = new SplitText(heading, {
			type: "lines",
			mask: "lines",
			linesClass: "line",
		});
		__ensureTrailingDivPlacement(split, trailingInfo);
		__splitRegistry.set(heading, split);
		heading.setAttribute("data-split-bound", "1");
		return split;
	}

	function __resplitAllHeadings() {
		const nodes = document.querySelectorAll('[data-split-bound="1"]');
		nodes.forEach((heading) => {
			__splitHeading(heading);
		});
	}

	function __bindResizeForSplit() {
		if (__splitResizeBound) return;
		__splitResizeBound = true;
		let rafId = null;
		let pending = false;
		const onResize = () => {
			if (pending) return;
			pending = true;
			// Wait a tick to let layout settle, then re-split
			rafId = requestAnimationFrame(() => {
				pending = false;
				__resplitAllHeadings();
			});
		};
		window.addEventListener("resize", onResize);
	}
	const handleEnter = ($item) => {
		if ($item.classList.contains("in-view")) return;

		const delayAttr = parseInt($item.dataset.delay || 0, 10) || 0;

		if ($item.classList.contains("in-view-detect")) {
			$item.classList.remove("in-view-detect");
			$item.classList.add("in-view");
		} else {
			$item.classList.add("in-view");
		}

		// Headings split animation
		const splitTargets = [];
		const seenTargets = new Set();

		const collectHeading = (node) => {
			if (!node || seenTargets.has(node)) return;
			seenTargets.add(node);
			splitTargets.push(node);
		};

		if ($item.classList.contains("split-text")) {
			collectHeading($item);
		}

		if (
			$item.parentElement &&
			$item.parentElement.classList.contains("child-split-text") &&
			$item.tagName.match(/^H[1-3]$/)
		) {
			collectHeading($item);
		}

		$item.querySelectorAll(".split-text").forEach(collectHeading);

		if ($item.classList.contains("child-split-text")) {
			$item.querySelectorAll("h1, h2, h3").forEach((node) => {
				if (node.classList.contains("split-text")) return;
				collectHeading(node);
			});
		}

		splitTargets.forEach((heading) => {
			__splitHeading(heading);
			setTimeout(() => {
				__animateHeadingLines(heading);
			}, delayAttr);
			__bindResizeForSplit();
		});

		// Scale-in animation (.js-s-scale), triggers once
		let targets = [];
		if ($item.classList.contains("js-s-scale")) {
			targets = [$item];
		} else {
			targets = Array.from($item.querySelectorAll(".js-s-scale"));
		}
		if (targets.length) {
			const delayMs = parseInt($item.dataset.delay || 0, 10) || 0;
			targets.forEach((el) => {
				if (el.dataset.scaleAnimated) return;
				el.dataset.scaleAnimated = "1";
				gsap.set(el, { "--scale": 1.35, force3D: true });
				gsap.to(el, {
					"--scale": 1,
					duration: 0.8,
					ease: "power3.out",
					delay: delayMs / 1000,
				});
			});
		}
	};

	// compute per-element threshold like the old logic
	const computeThreshold = ($item) => {
		const staticOffset = $item.dataset.inViewOffset;
		return staticOffset
			? parseFloat(staticOffset)
			: Math.min($item.offsetHeight / 4, 120);
	};

	// fallback path (scroll + getBoundingClientRect)
	const fallbackInit = () => {
		const blocks = document.querySelectorAll(
			".in-view-detect, .in-view-detect-tag > *"
		);
		const check = () => {
			const vh = window.innerHeight;
			blocks.forEach(($item) => {
				if (!$item || $item.classList.contains("in-view")) return;
				const rect = $item.getBoundingClientRect();
				const threshold = computeThreshold($item);
				const inView = rect.top - vh <= -threshold;
				if (inView) handleEnter($item);
			});
		};
		window.addEventListener("scroll", check, { passive: true });
		window.addEventListener("resize", check);
		check();
	};

	// IntersectionObserver path
	const ioInit = () => {
		const blocks = document.querySelectorAll(
			".in-view-detect, .in-view-detect-tag > *"
		);

		// We can't set per-element rootMargin on a single IO, so we observe all
		// and do the threshold check inside the callback.
		const observer = new IntersectionObserver(
			(entries, obs) => {
				const vh = window.innerHeight;
				entries.forEach((entry) => {
					const el = entry.target;
					if (!entry.isIntersecting || el.classList.contains("in-view")) return;

					// emulate old threshold
					const rect = entry.boundingClientRect;
					const threshold = computeThreshold(el);
					const inView = rect.top - vh <= -threshold;

					if (inView) {
						handleEnter(el);
						obs.unobserve(el); // run once
					}
				});
			},
			{
				root: null,
				rootMargin: "0px 0px 0px 0px",
				threshold: [0, 0.01, 0.1, 0.25, 0.5, 0.75, 1],
			}
		);

		blocks.forEach((el) => observer.observe(el));
	};

	// defer start (preserve original delay semantics)
	setTimeout(() => {
		if ("IntersectionObserver" in window) {
			ioInit();
		} else {
			fallbackInit();
		}
	}, delay);
}

// Delay Group Implementation
function delayGroupTransition() {
	const groups = document.querySelectorAll(".delay-group");

	function isHidden(el) {
		if (!el.offsetParent || el.getClientRects().length === 0) {
			return true;
		}

		const style = window.getComputedStyle(el);
		return style.display === "none" || style.visibility === "hidden";
	}

	groups.forEach((group) => {
		let index = Number(group.dataset.delay) || 0;

		const elements = group.querySelectorAll(
			".in-view-detect, .in-view-detect-tag > *, .hidden-detect"
		);

		elements.forEach((el) => {
			if (!isHidden(el)) {
				index++;
				const delay = index * 100;
				el.style.setProperty("--delay", `${delay}ms`);
				el.setAttribute("data-delay", delay);
			}
		});
	});
}

// Modals
let modalIframe = null;

function initModals() {
	document.querySelectorAll("[data-modal-toggle]").forEach((toggle) => {
		toggle.addEventListener("click", () => {
			const modalName = toggle.getAttribute("data-modal-toggle");
			const url = toggle.dataset.url !== undefined ? toggle.dataset.url : null;

			toggleModal(modalName, url);
		});
	});

	// Close any open modal when clicking outside its body
	document.addEventListener("click", (e) => {
		const openModal = document.querySelector("[data-modal].is-show");

		if (!openModal) return;

		if (e.target.classList.contains("s-modal__wrapper")) {
			closeModal(openModal.getAttribute("data-modal"));
		}

		if (e.target.closest("[data-modal-toggle]")) return;

		if (!e.target.closest("[data-modal].is-show")) {
			closeModal(openModal.getAttribute("data-modal"));
		}
	});
}

function __focusFirstModalInput(modal) {
	if (!modal) return;
	const input = modal.querySelector(
		'input:not([disabled]):not([type="hidden"])'
	);
	if (!input) return;
	const focus = () => {
		if (document.activeElement === input) return;
		try {
			input.focus({ preventScroll: true });
		} catch (e) {
			input.focus();
		}
	};
	if (modal.classList.contains("is-animate")) {
		requestAnimationFrame(() => requestAnimationFrame(focus));
		return;
	}
	requestAnimationFrame(focus);
}

function openModal(modalName, url) {
	const modal = document.querySelector(`[data-modal="${modalName}"]`);
	if (modal) {
		// Determine the highest z-index among currently open modals
		const openModals = Array.from(
			document.querySelectorAll("[data-modal].is-show")
		);
		let highestZ = 10000;
		openModals.forEach((m) => {
			const z = parseInt(window.getComputedStyle(m).zIndex, 10) || highestZ;
			if (z > highestZ) highestZ = z;
		});
		// Assign this modal a z-index above the rest
		modal.style.zIndex = (highestZ + 1).toString();

		modal.classList.remove("is-hide");
		modal.classList.add("is-show");

		document.body.classList.add("modal-open");

		if (modal.dataset.modalType === "iframe") {
			const container = modal.querySelector(".s-modal__iframe");
			modalIframe = createVideoIframe(url, container);
		}

		const isMenuModal = modalName === "menu";

		if (!isMenuModal) {
			__focusFirstModalInput(modal);
		}

		if (isMenuModal) {
			document.querySelector("body").classList.add("is-menu-open");
			document.querySelector(".header__burger").classList.add("is-active");
		}

		bodyLock();
	}
}

function closeModal(modalName) {
	const modal = document.querySelector(`[data-modal="${modalName}"]`);
	if (modal) {
		modal.classList.remove("is-show");
		modal.classList.add("is-hide");

		document.body.classList.remove("modal-open");

		if (modal.dataset.modalType === "iframe") {
			pauseVideo(modalIframe);
		}

		const isMenuModal = modalName === "menu";

		if (isMenuModal) {
			document.querySelector("body").classList.remove("is-menu-open");
			document.querySelector(".header__burger").classList.remove("is-active");
		}

		// Remove custom z-index after fade-out
		setTimeout(() => {
			modal.style.zIndex = "";
		}, 400);

		bodyUnlock();

		// Set flag so scroll handler preserves header state on next tick
		__justClosedModal = true;
		// Recalculate header state after modal closes
		setTimeout(() => {
			window.dispatchEvent(new Event("scroll"));
		}, 0);
	}
}

function toggleModal(modalName, url) {
	const modal = document.querySelector(`[data-modal="${modalName}"]`);
	modal.classList.contains("is-show")
		? closeModal(modalName)
		: openModal(modalName, url);
}

function createVideoIframe(videoUrl, container, autoplay = true) {
	if (!container) return false;

	let embedUrl = "";
	let iframeAttributes = {
		allow: "autoplay; encrypted-media; fullscreen; picture-in-picture",
		frameborder: "0",
		allowfullscreen: true,
	};

	if (videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be")) {
		const videoId = videoUrl
			.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)[2]
			.split(/[^0-9a-z_-]/i)[0];
		embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=${
			autoplay ? 1 : 0
		}&enablejsapi=1`;
	} else if (videoUrl.includes("vimeo.com")) {
		const videoId = videoUrl.split("/").pop();
		embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=${
			autoplay ? 1 : 0
		}&api=1&background=0`;
	} else {
		console.error("error format video");
		return;
	}

	const iframe = document.createElement("iframe");
	iframe.src = embedUrl;

	Object.keys(iframeAttributes).forEach((attr) => {
		iframe.setAttribute(attr, iframeAttributes[attr]);
	});

	container.innerHTML = "";
	container.appendChild(iframe);

	return iframe;
}

function pauseVideo(iframe) {
	if (!iframe) return;
	const frameWindow = iframe.contentWindow;
	if (!frameWindow) {
		iframe.remove();
		if (iframe === modalIframe) modalIframe = null;
		return;
	}
	if (iframe.src.includes("youtube.com")) {
		frameWindow.postMessage(
			'{"event":"command","func":"pauseVideo","args":""}',
			"*"
		);
	} else if (iframe.src.includes("vimeo.com")) {
		frameWindow.postMessage('{"method":"pause"}', "*");
	}
	iframe.remove();
	if (iframe === modalIframe) modalIframe = null;
}

function toggleBodyLock(action) {
	const method = action === "lock" ? "addClass" : "removeClass";

	$("html, body")[method]("lock");

	if (typeof lenisScroll !== "undefined" && lenisScroll) {
		action === "lock" ? lenisScroll.stop() : lenisScroll.start();
	} else {
		if (action === "lock") {
			const scrollY = window.scrollY;
			document.body.style.position = "fixed";
			document.body.style.top = `-${scrollY}px`;
			document.body.style.width = "100%";
			document.body.style.overflow = "hidden";
			document.body.setAttribute("data-scroll-y", scrollY);
		} else {
			const scrollY = document.body.getAttribute("data-scroll-y");
			document.body.style.position = "";
			document.body.style.top = "";
			document.body.style.width = "";
			document.body.style.overflow = "";
			document.body.removeAttribute("data-scroll-y");
			window.scrollTo(0, parseInt(scrollY || "0"));
		}
	}
}

function bodyLock() {
	toggleBodyLock("lock");
}

function bodyUnlock() {
	toggleBodyLock("unlock");
}

function bodyLockToggle() {
	const isLocked = document.body.classList.contains("lock");
	toggleBodyLock(isLocked ? "unlock" : "lock");
}

document.addEventListener("DOMContentLoaded", function () {
	gsap.registerPlugin(SplitText, CustomEase);

	// Wait for web fonts, fallback if not supported
	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(() => {
			initInViewDetect();
			delayGroupTransition();
			initModals();
		});
	} else {
		// Safari without Font Loading API: run on window load
		window.addEventListener("load", () => {
			initInViewDetect();
			delayGroupTransition();
			initModals();
		});
	}

	// Lenis Scroll
	if (window.innerWidth > 1279 && !document.querySelector(".no-lenis")) {
		setTimeout(() => {
			lenisScroll = new Lenis({
				duration: 1.2,
				lerp: 0.1,
				smoothTouch: true,
				easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
			});

			function raf(time) {
				lenisScroll.raf(time);
				requestAnimationFrame(raf);
			}

			requestAnimationFrame(raf);

			if (isMobile.any()) {
				lenisScroll.destroy();
			}
		}, 200);
	}

	scrollTopPos = window.scrollY;
	let scrollDirectionNative = null;

	// Sticky Header + Button
	const $header = $(".header");

	window.addEventListener("scroll", () => {
		// Freeze header state while a modal is open
		if (document.body.classList.contains("modal-open")) {
			return;
		}

		if (__justClosedModal) {
			__justClosedModal = false;

			// Ensure correct fixed state
			if (window.scrollY > 400) {
				if (!$header.hasClass("is-fixed")) {
					$header.css("transition-duration", "0s");
					$header.addClass("is-fixed");
					setTimeout(() => {
						$header.removeAttr("style");
					}, 0);
				}
			} else {
				$header.removeClass("is-fixed");
			}

			// Ensure active state without requiring an 'up' scroll
			if (window.scrollY > 600) {
				$header.addClass("is-active");
			} else {
				$header.removeClass("is-active");
			}

			// Sync tracker and stop further processing this tick
			scrollTopPos = window.scrollY;
			return;
		}

		if (!$header.hasClass("is-sticky")) {
			if (scrollTopPos > window.scrollY) {
				scrollDirectionNative = "up";
			} else {
				scrollDirectionNative = null;
			}

			if (window.scrollY > 200) {
				if (!$header.hasClass("is-fixed")) {
					$header.css("transition-duration", "0s");
					$header.addClass("is-fixed");
					setTimeout(() => {
						$header.removeAttr("style");
					}, 0);
				}
			} else {
				$header.removeClass("is-fixed");
			}

			if (window.scrollY > 400) {
				if (scrollDirectionNative === "up") {
					$header.addClass("is-active");
				} else {
					$header.removeClass("is-active");
				}
			} else {
				$header.removeClass("is-active");
			}

			scrollTopPos = window.scrollY;
		} else {
			if (window.scrollY > 20) {
				$header.addClass("is-scrolling");
			} else {
				$header.removeClass("is-scrolling");
			}
		}
	});

	// Coming Soon slider
	(function initComingSoonSlider() {
		if (typeof Swiper === "undefined") return;

		const sliderEl = document.querySelector(".s-coming-soon__slider");
		if (!sliderEl) return;

		const currentCounter = document.querySelector(
			".s-coming-soon__counter--current"
		);
		const totalCounter = document.querySelector(
			".s-coming-soon__counter--total"
		);
		const slidesCount = sliderEl.querySelectorAll(".swiper-slide").length;

		const formatCounter = (value) => `${value}`;

		if (totalCounter && slidesCount) {
			totalCounter.textContent = formatCounter(slidesCount);
		}

		const updateCurrentCounter = (swiperInstance) => {
			if (!currentCounter) return;
			const index = (slidesCount > 1 ? swiperInstance.realIndex : 0) + 1;
			currentCounter.textContent = formatCounter(index);
		};

		const swiperOptions = {
			slidesPerView: 1,
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			loop: slidesCount > 1,
			speed: 800,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: ".s-coming-soon__arrow--next",
				prevEl: ".s-coming-soon__arrow--prev",
			},
			on: {
				init(swiperInstance) {
					updateCurrentCounter(swiperInstance);
				},
				slideChange(swiperInstance) {
					updateCurrentCounter(swiperInstance);
				},
			},
		};

		const progressEl = document.querySelector(
			".s-coming-soon__progress .swiper-scrollbar"
		);

		if (progressEl) {
			swiperOptions.scrollbar = {
				el: progressEl,
				draggable: true,
			};
		}

		new Swiper(sliderEl, swiperOptions);
	})();
});
// Email Capture Modal Handler
function initEmailCaptureModal() {
	const modal = document.getElementById('emailCaptureModal');
	const closeBtn = document.querySelector('.modal-close');
	const successMessage = document.getElementById('successMessage');

	function closeModalWithAnimation() {
		if (!modal) return;
		modal.classList.add('closing');
		setTimeout(() => {
			modal.style.display = 'none';
			modal.classList.remove('closing');
		}, 300);
	}

	if (modal) {
		// Check if success message is visible (form was already submitted)
		const isSuccessShowing = successMessage && successMessage.style.display !== 'none';

		if (isSuccessShowing) {
			// Show modal immediately if success message exists
			modal.style.display = 'flex';
		} else {
			// Show modal after 5 seconds if form hasn't been submitted
			setTimeout(() => {
				modal.style.display = 'flex';
			}, 5000);
		}

		// Close modal on close button click
		if (closeBtn) {
			closeBtn.addEventListener('click', function() {
				closeModalWithAnimation();
			});
		}

		// Close modal on overlay click
		modal.addEventListener('click', function(e) {
			if (e.target === modal) {
				closeModalWithAnimation();
			}
		});
	}
}

// Initialize email capture modal when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
	initEmailCaptureModal();
});